module.exports = {
	"header": "Login",
	"facebook": "Sign in with Facebook",
	"google": "Sign in with Google",
	"linkedin": "Sign in with LinkedIn",
	"register": "Register",
	"sellerHeader": "Seller Login",
	"noAccountRegister": "Do not have an account? <registerLink>$t(login::register) now</registerLink>"
}


//////////////////
// WEBPACK FOOTER
// /private/var/folders/n9/yczdnstj3wdc9q5tzm6d45c00000gp/T/maison-encans-auex-website/~/@auex/locales/lib/en/login.json5
// module id = 1938
// module chunks = 6